import React from 'react'
import ModalsController from './../shared/Modals.controller'
import UserProfileService from './../../../shared/services/UserProfile.service'
import LoadingSpinner from './../../shared/LoadingSpinner.component'
import {
  phoneToStorage,
  phoneToView,
} from './../../../shared/formatters/telephone.formatter'
import {
  MDBBtn,
  MDBAlert,
  MDBDataTable,
  MDBIcon,
  MDBModalHeader,
  MDBModalBody,
  MDBModal,
} from 'mdbreact'
import UserService from './../../../shared/services/User.service'
import StorageService from './../../../shared/services/Storage.service'
import QuotationTabs from './../../newhome/QuotationTabs'

import './QuotePopupModal.component.scss'

const MODAL_ID = 'modals.quote-popup',
  MODAL_BODY_CLASS = 'quote-modal-open',
  POPUP_TIMER = {
    int: null,
    clear: () => {
      if (typeof POPUP_TIMER.int === 'number')
        window.clearTimeout(POPUP_TIMER.int)
      POPUP_TIMER.int = null
    },
    delay: 6000,
  }

const isJson = (str) => {
  try {
    return !!JSON.parse(str)
  } catch (ex) {
    return false
  }
}

class QuotePopupModal extends React.Component {
  state = {
    isLoading: false,
    isOpen: false,
  }

  _isOpen = () => this.state.isOpen === true

  _isAutoOpen = () => this._.params(MODAL_ID, 'autoOpen') !== false

  _getStored = () => {
    let stored = StorageService.get(MODAL_ID)
    return stored && isJson(stored) ? JSON.parse(stored) : false
  }

  _setStored = () => {
    StorageService.set(MODAL_ID, new Date().getTime())
  }

  _shouldClear = () => {
    const stored = this._getStored()
    return (
      stored && !isNaN(stored) && new Date().getTime() - 86400000 * 30 > stored
    )
    return false
  }

  _clear = () => {
    try {
      POPUP_TIMER.clear()
    } catch (ex) {}
  }

  _shouldOpen = () => {
    // is component disabled?
    if (this.props?.disabled === true) return false

    // has the modal previously been supressed?
    const stored = this._getStored()
    if (stored) {
      // is it over 30 days? if so, clear.
      if (this._shouldClear()) {
        this._clear()
        return true
      }

      return false
    }

    return true
  }

  _toggle = () => {
    const isOpen = !this.state.isOpen
    try {
      if (isOpen) this._.checkCanOpen(MODAL_ID)
      this._[isOpen ? 'open' : 'close'](MODAL_ID)
    } catch (ex) {
      return false
    }
    this.setState({ isOpen })
  }

  componentDidMount() {
    this._ = ModalsController.init(MODAL_ID, {
      autoOpen:
        !isNaN(this.props?.autoOpen) && this.props.autoOpen > 0
          ? parseInt(this.props.autoOpen)
          : false,
      bodyClass: MODAL_BODY_CLASS,
    })

    if (this._isAutoOpen()) {
      if (POPUP_TIMER.int && typeof POPUP_TIMER.int === 'number')
        POPUP_TIMER.clear()

      POPUP_TIMER.int = setTimeout(() => {
        if (POPUP_TIMER.int && typeof POPUP_TIMER.int === 'number')
          POPUP_TIMER.clear()
        if (this._shouldOpen()) this._toggle()
      }, this.props.autoOpen || POPUP_TIMER.delay)
    }
  }

  componentWillUnmount() {
    if (this._isAutoOpen()) {
      if (POPUP_TIMER.int && typeof POPUP_TIMER.int === 'number')
        POPUP_TIMER.clear()
    }
  }

  render() {
    return (
      <MDBModal
        size="lg"
        isOpen={this.state.isOpen}
        toggle={this._toggle}
        id="QuotePopupModalComponent"
        disableBackdrop={true}
      >
        <MDBModalHeader toggle={this._toggle}>Get Quoted Now!</MDBModalHeader>
        <MDBModalBody className={this.state.isLoading ? 'is-loading' : ''}>
          {this.state.isLoading ? (
            <div className="loading-wrapper">
              <LoadingSpinner size="md" isActive={true} />
            </div>
          ) : (
            <>
              <div>
                <QuotationTabs
                  insuranceType={this.props.insuranceType}
                  onSuccess={(response) => {
                    this._setStored()
                    this._clear()
                    setTimeout(() => this.setState({ isOpen: false }))
                  }}
                  onFailure={() => {}}
                />
              </div>
            </>
          )}
        </MDBModalBody>
      </MDBModal>
    )
  }
}

export default QuotePopupModal
